export default __webpack_public_path__ + "static/media/machine-gray.faf1b91b.svg";